import '@fontsource/figtree/400.css';
import '@fontsource/figtree/500.css';
import '@fontsource/figtree/600.css';
import '@fontsource/figtree/700.css';
import '@fontsource/bricolage-grotesque/700.css';
import '@fontsource/bricolage-grotesque/800.css';
import '@fontsource/jetbrains-mono/500.css';
import './styles/base.css';
// Billtoro: eigene Farben und Logo, nur mit <html data-produkt="billtoro">; nach base.css laden (siehe billtoro.css)
import './styles/billtoro.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { SessionProvider } from './auth/session';
import { LangProvider } from './i18n';
import { setupNativeApp } from './lib/native';
import { ToastProvider } from './lib/toast';

setupNativeApp();

// Neue Adressen sofort anzeigen, nicht als Übergang (startTransition): Sonst kann React bei schnellem Zurück den
// eigenen Verlaufseintrag eines Fensters (Sammelfotos, Glocke) überspringen, und das Fenster bliebe offen.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter useTransitions={false}>
      <ToastProvider>
        <SessionProvider>
          <LangProvider>
            <App />
          </LangProvider>
        </SessionProvider>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);
